import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, withComponentInputBinding, PreloadAllModules, withPreloading } from "@angular/router";

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { provideTransloco } from "@jsverse/transloco";
import { provideTanStackQuery, QueryClient } from "@tanstack/angular-query-experimental";
import { routes } from "./app.routes";
import { HttpErrorInterceptor } from "./common/interceptors/http-error.interceptor";
import { TranslocoHttpLoader } from "./transloco-loader";
import { withDevtools } from "@tanstack/angular-query-experimental/devtools/production";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),
    provideTanStackQuery(
      new QueryClient(),
      withDevtools(() => ({
        buttonPosition: "bottom-left",
        //loadDevtools: inject(DevtoolsOptionsManager).loadDevtools(),
        //initialIsOpen: true,
      })),
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    provideHttpClient(),
    provideTransloco({
      config: {
        availableLangs: ["de", "en"],
        defaultLang: "de",
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
